import HeaderTamplate from './HeaderTamplate';

export default HeaderTamplate;
